const articles = document.querySelectorAll('article.vagas__card');
let isDragging = false;

function handleEvent(event, element) {
    const innerButtons = element.querySelectorAll('.button,.vagas__card__share'); // selecione o botão interno
    if (element.closest('.swiper-slide-active')) {
        if (
            (event.type === 'pointerup' && !isDragging) ||
            (event.type === 'keydown' && (event.keyCode === 13 || event.keyCode === 32 || event.code === 'Enter' || event.code === 'Space'))
        ) {
            if (element.dataset.permalink) {
                let clickInnerButton = false;
                innerButtons.forEach((innerButton) => {
                    if (innerButton && innerButton.contains(event.target)) {
                        // verifique se o evento ocorreu no botão interno
                        isDragging = false;
                        clickInnerButton = true;
                    }
                });

                if (clickInnerButton) {
                    return; // interrompa o evento para evitar que o link seja aberto duas vezes
                }

                const permalink = element.dataset.permalink;
                const newTab = window.open(permalink, '_blank');
                newTab.addEventListener('blur', () => {
                    element.focus();
                });
                element.setAttribute('aria-describedby', 'link-aberto');
                isDragging = true;
                setTimeout(() => {
                    element.removeAttribute('aria-describedby');
                    element.blur();
                }, 5000);
            }
            isDragging = false;
        } else if (event.type === 'pointerdown') {
            isDragging = false;
        } else if (event.type === 'pointermove') {
            isDragging = true;
        }
    }
}

// if (!/Mobile|Tablet/i.test(navigator.userAgent)) {}
articles.forEach((article, index) => {
    article.setAttribute('tabindex', 0);
    article.setAttribute('role', 'article');
    article.addEventListener('pointerup', (event) => handleEvent(event, article));
    article.addEventListener('pointerdown', (event) => handleEvent(event, article));
    article.addEventListener('pointermove', (event) => handleEvent(event, article));
    article.addEventListener('keydown', (event) => handleEvent(event, article));
    article.addEventListener('click', (event) => {
        handleEvent(event, article);
        isDragging = false;
    });
});
